class ShopifyProductRecommendations extends window.BAO.CustomElement() {
  static get requiredAttributes() {
    return ["data-recommendations-url", "data-product-id", "data-section-id"];
  }

  static get observedAttributes() {
    return ["data-product-id"];
  }

  async attributeChangedCallback(name) {
    if (name !== "data-product-id") return;

    await this.render();
  }

  async render() {
    this.innerHTML = await this.fetch();
  }

  async fetch() {
    if (!this.productId?.length) return "";

    const html = this.cachedHTML || (await this.fetchRecommendations());

    if (!html || !html.length) return;

    this.updateCache({
      productId: this.productId,
      html,
    });

    return html;
  }

  async fetchRecommendations() {
    const response = await fetch(`${this.recommendationsUrl}?${this.params}`);
    const text = await response.text();

    return this.sectionRenderer.getInnerHtml(text);
  }

  updateCache({ productId, html }) {
    const cache = this.cache || {};
    cache[productId] = html;

    window.sessionStorage.setItem(this.storageKey, JSON.stringify(cache));
  }

  get sectionRenderer() {
    return window.BAO.sectionRenderer;
  }

  get cachedHTML() {
    return this.cache?.[this.productId];
  }

  get cache() {
    const cache = window.sessionStorage.getItem(this.storageKey);

    return cache ? JSON.parse(cache) : {};
  }

  get params() {
    // eslint-disable-next-line compat/compat
    const params = new URLSearchParams();
    params.set("product_id", this.productId);
    params.set("section_id", this.sectionId);
    params.set("limit", this.limit);

    return params.toString();
  }

  get recommendationsUrl() {
    return this.dataset.recommendationsUrl;
  }

  get productId() {
    return this.dataset.productId;
  }

  get sectionId() {
    return this.dataset.sectionId;
  }

  get limit() {
    return this.dataset.limit || 10;
  }

  get storageKey() {
    return `BAO-product-recommendations-${this.sectionId}-${this.limit}`;
  }
}

if (!window.customElements.get("shopify-product-recommendations")) {
  window.customElements.define(
    "shopify-product-recommendations",
    ShopifyProductRecommendations,
  );
}
